var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaginationNext = function SvgIconPaginationNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.042 14.827a.833.833 0 1 0 1.178 1.179l4.828-4.828c.65-.65.65-1.706 0-2.357L12.22 3.994a.833.833 0 1 0-1.178 1.179l3.994 3.994H3.298a.833.833 0 1 0 0 1.666h11.738z"
  })));
};
export default SvgIconPaginationNext;